import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    connect() {
      this.checkVisibility();
      window.addEventListener('scroll', () => this.checkVisibility());
    }

    checkVisibility() {
        if (!this.element.classList.contains('hidden')) {
            return;
        }

        const parentRect = this.element.parentElement.getBoundingClientRect();
        const isVisible = parentRect.top < window.innerHeight && parentRect.bottom >= 0;

        if (isVisible) {
            this.element.classList.remove('hidden');
            this.element.classList.add('slide-in-right'); // Add the custom animation class
            window.removeEventListener('scroll', () => this.checkVisibility());
        }
    }

    toggleTranslate() {
        this.element.classList.add('slide-out-right');
    }

    disconnect() {
        window.removeEventListener('scroll', () => this.checkVisibility());
    }
}
